import { shouldForwardProp } from '@/utils/style.utils';
import styled from '@emotion/styled';

const ImageWrapper = styled('div', { shouldForwardProp })<{ $height: string; $width: string }>`
  position: relative;
  height: ${({ $height }) => $height};
  width: ${({ $width }) => $width};
  span,
  img {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`;

export default { ImageWrapper };
